module.exports = __webpack_public_path__ + "f52ebbcfec381f3b63b9d997a8f6c108.png";